"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _doctifyModal = require("./doctify-modal");

var _doctifyModal2 = _interopRequireDefault(_doctifyModal);

var _hospitalListModal = require("../../src/styles/hospital-list-modal.scss");

var _hospitalListModal2 = _interopRequireDefault(_hospitalListModal);

var _constants = require("../../../specialist-page/src/utils/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HospitalListModal = function HospitalListModal(props) {
  var selectedHospitalList = props.selectedHospitalList,
      closeModal = props.closeModal,
      hospitalListChoices = props.hospitalListChoices,
      chooseHospitalList = props.chooseHospitalList;


  var isConsultantSelect = selectedHospitalList && selectedHospitalList.id === _constants.CONSULTANT_SELECT_HOSPITAL_LIST_ID;
  var isNotOnList = selectedHospitalList && selectedHospitalList.id === _constants.I_CANT_SEE_MY_LIST_ID;
  return _react2.default.createElement(
    _doctifyModal2.default,
    {
      closeModal: function closeModal() {} // close only with 'I Understand' button
      , className: _hospitalListModal2.default['modal-container'],
      headerClass: _hospitalListModal2.default.header,
      titleClass: _hospitalListModal2.default.title,
      bodyClass: _hospitalListModal2.default.body,
      header: !isConsultantSelect && 'Staying on list',
      showClose: false
    },
    isNotOnList ? _react2.default.createElement(
      "div",
      null,
      _react2.default.createElement(
        "p",
        null,
        "The consultant you have chosen does not work at any practices on your hospital list"
      ),
      _react2.default.createElement(
        "p",
        null,
        "Please go back to the Finder homepage and search using your hospital list"
      ),
      _react2.default.createElement(
        "p",
        null,
        "You  must see a consultant at a hospital on your list. Having treatment at a practice not on your hospital list will leave you open to paying for a large portion of the hospital costs yourself"
      ),
      _react2.default.createElement(
        "div",
        { className: _hospitalListModal2.default.btnContainer },
        _react2.default.createElement(
          "button",
          {
            className: "btn " + _hospitalListModal2.default.btnPrimary,
            onClick: function onClick() {
              return window.location.href = '/';
            }
          },
          "Go To Finder"
        )
      )
    ) : _react2.default.createElement(
      "div",
      null,
      isConsultantSelect ? _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "p",
          { className: _hospitalListModal2.default.title + " " + _hospitalListModal2.default['title_small'] },
          "You\u2019re on our consultant select option"
        ),
        _react2.default.createElement(
          "p",
          null,
          "Our finder will now show you consultant choices that are relevant to your cover"
        ),
        _react2.default.createElement(
          "div",
          { className: _hospitalListModal2.default.btnContainer },
          _react2.default.createElement(
            "button",
            { className: "btn " + _hospitalListModal2.default.btnPrimary, onClick: closeModal },
            "Ok"
          )
        )
      ) : _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "p",
          null,
          "Before booking or calling your selected consultant, please make sure that you are arranging to be seen at a practice that is on your hospital list."
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "p",
            null,
            "We\u2019ve tailored this search to include practices on your list but sometimes your consultant may work at a number of other practices."
          ),
          _react2.default.createElement(
            "p",
            null,
            "It\u2019s important to check the one you are attending is on your list."
          )
        ),
        selectedHospitalList && _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(
            "span",
            null,
            "Your selected hospital list is:"
          ),
          _react2.default.createElement(
            "span",
            { className: _hospitalListModal2.default.title },
            selectedHospitalList.name
          )
        ),
        selectedHospitalList && _react2.default.createElement(
          "p",
          null,
          _react2.default.createElement(
            "span",
            null,
            "Please check this symbol is displayed under the practice name you\u2019re selecting."
          ),
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "span",
            { className: _hospitalListModal2.default.insurer },
            selectedHospitalList.shortName
          )
        ),
        _react2.default.createElement(
          "p",
          { className: _hospitalListModal2.default.warning },
          "Having treatment at a practice not on your hospital list will leave you open to paying for a large portion of the hospital costs yourself."
        ),
        selectedHospitalList && _react2.default.createElement(
          "div",
          { className: _hospitalListModal2.default.btnContainer },
          _react2.default.createElement(
            "button",
            { className: "btn " + _hospitalListModal2.default.btnPrimary, onClick: closeModal },
            "I Understand"
          )
        ),
        !selectedHospitalList && _react2.default.createElement(
          "div",
          { className: _hospitalListModal2.default.selectContainer },
          _react2.default.createElement(
            "div",
            null,
            "Choose your hospital list:"
          ),
          _react2.default.createElement(
            "select",
            {
              onChange: function onChange(event) {
                chooseHospitalList(event.target.value);
              },
              className: _hospitalListModal2.default.select
            },
            _react2.default.createElement(
              "option",
              { disabled: true, selected: true },
              "Please Select*"
            ),
            hospitalListChoices.map(function (item) {
              return _react2.default.createElement(
                "option",
                { value: item.id, key: item.id },
                item.name
              );
            })
          )
        )
      )
    )
  );
};

HospitalListModal.propTypes = {
  selectedHospitalList: require("react").PropTypes.shape({
    id: require("react").PropTypes.number.isRequired,
    name: require("react").PropTypes.string.isRequired,
    shortName: require("react").PropTypes.string.isRequired
  }),
  hospitalListChoices: require("react").PropTypes.arrayOf(require("react").PropTypes.shape({
    id: require("react").PropTypes.number.isRequired,
    name: require("react").PropTypes.string.isRequired
  })).isRequired,
  closeModal: require("react").PropTypes.func.isRequired,
  chooseHospitalList: require("react").PropTypes.func.isRequired
};
HospitalListModal.displayName = 'HospitalListModal';

exports.default = HospitalListModal;


// WEBPACK FOOTER //
// ./components/doctify-modals/lib/components/hospital-list-modal.js